import moment from 'moment';

export const checkHoursOfOperation = ({
  hoursOfOperation = {},
  orderDate,
  orderTime,
  minAdvanceNoticeTime = 0,
  maxAdvanceDays = null,
}) => {
  const isNow = orderDate === 'now';

  if (!isNow && !orderTime == null) return false;

  // Use current time if 'now', else parse date and time with moment
  const getOrderTime = (orderDate, orderTime) => {
    if (orderDate === 'now') {
      return moment();
    } else if (typeof orderDate === 'number') {
      // Parse time separately and use to adjust orderDate moment
      const time = moment(orderTime, 'hh:mm A');
      return moment(orderDate)
        .set({ hours: time.hour() }, { minutes: time.minute() })
        .startOf('minute');
    }
  };

  const expectedOrderTime = getOrderTime(orderDate, orderTime);

  if (!moment.isMoment(expectedOrderTime)) return false;

  // Grab the hours for a given day and adjust for hour ranges that
  // continue to the next day
  const getHours = (hoursData, day) => {
    const hours = hoursData[day];
    const today = moment();
    const isYesterday =
      moment(today)
        .subtract('1', 'day')
        .format('dddd') === day;

    if (!hours) return null;

    const parsedHours = {
      start: moment(hours.starttime, 'hh:mm:a').startOf('minute'),
      end: moment(hours.endtime, 'hh:mm:a')
        .endOf('minute')
        .subtract(minAdvanceNoticeTime, 'minutes'),
    };

    if (isYesterday) {
      parsedHours.start.subtract('1', 'day');
      parsedHours.end.subtract('1', 'day');
    }

    if (
      parsedHours.end.hour() < 12 &&
      parsedHours.end.isSameOrBefore(parsedHours.start)
    ) {
      parsedHours.end.add('1', 'day');
    }

    return parsedHours;
  };

  // Check if a given time is within a day's hour range
  const checkHours = (orderTime, { start, end }, { isNow, noticeTime }) => {
    if (!isNow) {
      const adjustedStart = moment(start).add(noticeTime, 'minutes');
      return orderTime.isBetween(adjustedStart, end);
    }

    return orderTime.isBetween(start, end);
  };

  // Get today's hours and check if order time is within hours of operation
  const yesterday = moment(expectedOrderTime)
    .subtract('1', 'day')
    .format('dddd');
  const yesterdaysHours = getHours(hoursOfOperation, yesterday, true);

  if (
    yesterdaysHours &&
    checkHours(expectedOrderTime, yesterdaysHours, {
      isNow,
      noticeTime: minAdvanceNoticeTime,
    })
  ) {
    return true;
  }

  const today = expectedOrderTime.format('dddd');
  const todaysHours = getHours(hoursOfOperation, today);

  if (!todaysHours) return false;

  const isWithinMaxAdvanceDays = (orderDate, maxAdvanceDays) => {
    if (maxAdvanceDays == null) return true;

    return expectedOrderTime.isBefore(moment().add(maxAdvanceDays, 'days'));
  };

  return (
    checkHours(expectedOrderTime, todaysHours, {
      isNow,
      noticeTime: minAdvanceNoticeTime,
    }) && isWithinMaxAdvanceDays(expectedOrderTime, maxAdvanceDays)
  );
};



// WEBPACK FOOTER //
// ./src/util/lavu.js